export const message = {
    loginPrompt:"We’ve saved everything — log in to keep going!"
}